import airfareSearch from './airfare-search-reducer';

export * from './airfare-search-reducer';
export default airfareSearch;
